module.exports = __webpack_public_path__ + "img/logo.71e936b.35a4fbc1.png";